import { render } from "./ConfirmSizeLabels.vue?vue&type=template&id=5a3c0bf4"
import script from "./ConfirmSizeLabels.vue?vue&type=script&lang=js"
export * from "./ConfirmSizeLabels.vue?vue&type=script&lang=js"

import exportComponent from "/Users/chrismains/Sites/fixmycar/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__